//TODO: WindowSize is for demo mode only at this point. See PR for good refactors if we
//      implement this in the real app: https://github.com/AmiraLearning/lexa-studentapp/pull/1189

import React, { useEffect, useState } from "react";
import FaExpand from 'react-icons/lib/fa/expand';
import {COPY_STRINGS} from '../constants/translatedCopy';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export const WindowSize = () => {
  const { height, width } = useWindowDimensions();
  const minWidth = 700;
  const minHeight = 400;
  const tooSmall = width < minWidth || height < minHeight;

  return (
    tooSmall ?
      <div className="modalBackground windowSize">
        <div className="modalContainer">
          <div className="restartModal">
            <div className="alert">{COPY_STRINGS.window_size_too_small}</div>
            <div className="iconContainer">
              <FaExpand height="50" width="40" className="icon"/>
            </div>
            <div className="explanation labelFontOverride">{COPY_STRINGS.window_size_not_supported}</div>
          </div>
        </div>
      </div>
      : null
  );
};